import { render } from "./TheHeader.vue?vue&type=template&id=34161555&scoped=true"
import script from "./TheHeader.vue?vue&type=script&scoped=true&lang=js"
export * from "./TheHeader.vue?vue&type=script&scoped=true&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=34161555&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34161555"]])

export default __exports__